module.exports = __webpack_public_path__ + "img/wertheim-logo.b8f9efdb.svg";